import React, { ComponentProps, FC } from 'react';
import { useLocation } from 'react-router-dom';

import ESSearchResultsLayout from '../../../components/layouts/ESSearchResultsLayout';
import SearchResultsContainer from '../../../containers/searchResults';
import useElasticSearchQuery from '../../../hooks/elasticSearch/useEsSmartViewQuery/useElasticSearchQuery';
import useParamHotelId from '../../../hooks/router/params/useParamHotelId';
import useParamQuickFilter from '../../../hooks/router/params/useParamQuickFilter';
import useParamTopicId from '../../../hooks/router/params/useParamTopicId';
import { getTopicUrl } from '../../urls/topic';

type LayoutConfig = ComponentProps<typeof ESSearchResultsLayout>['config'];

/**
 * Filters page
 *
 * @returns Filters page layout
 */
const PageFilters: FC = () => {
  const hotelId = useParamHotelId();
  const location = useLocation();
  const queryId = useParamQuickFilter();
  const topicId = useParamTopicId();

  const esQuery = useElasticSearchQuery({
    context: { topicId },
    id: queryId ?? '',
  });

  const layoutConfig: LayoutConfig = {
    backUrl: getTopicUrl(hotelId, location, topicId),
    isLoadingTitle: false,
    title: esQuery.title ?? '',
  };

  return (
    <ESSearchResultsLayout config={layoutConfig}>
      <SearchResultsContainer esQuery={esQuery} />
    </ESSearchResultsLayout>
  );
};

export default PageFilters;
